import { TicketCreate, Ticket, TicketOverview } from 'projects/access-gui/views/ticket'

module.exports = [
  {
    path: '/ticket/create/:accessId',
    exact: true,
    component: TicketCreate
  },
  {
    path: '/ticket/create/:accessId/:service',
    exact: true,
    component: TicketCreate
  }, {
    path: '/ticket',
    exact: true,
    component: TicketOverview
  }, {
    path: '/ticket/:ticketId',
    exact: true,
    component: Ticket
  }
]



// WEBPACK FOOTER //
// ./src/projects/access-gui/routes/ticket.js